import { Uniform } from 'three';
import { BlendFunction, Effect } from 'postprocessing';

export class CurveEffect extends Effect {
	constructor({ distance = 34, strength = 1 } = {}) {
		super(
			'CurveEffect',
			` 
        uniform float uDistance;
        uniform float uStrength;

        void mainUv(inout vec2 uv) {
          float str = uStrength * -.05;
          uv.x += (uv.x * 2. - 1.) * str * pow(1. - uv.y, uDistance);
        }
      `,
			{
				blendFunction: BlendFunction.NORMAL,
				uniforms: new Map([
					['uDistance', new Uniform(distance)],
					['uStrength', new Uniform(strength)],
				]),
			}
		);
	}
}

export const vertexShader = `
    varying vec2 vUv;
    
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const fragmentShader = `
    uniform float uDistance;
    uniform float uStrength;
    varying vec2 vUv;

    void main() {
        float str = uStrength * -.05;
        vec2 uv = vUv;
        uv.x += (uv.x * 2. - 1.) * str * pow(1. - uv.y, uDistance);
        gl_FragColor = texture2D(tDiffuse, uv);
    }
`;

// Optional: Export a function to create the material
export function createCurveMaterial({ distance = 34, strength = 1 } = {}) {
	return {
		uniforms: {
			uDistance: { value: distance },
			uStrength: { value: strength },
			tDiffuse: { value: null },
		},
		vertexShader,
		fragmentShader,
	};
}
